import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../offline/queryKeys";
import {
  fetchClassStudents,
  fetchClassMeta,
  fetchAttendanceSubmissions,
  fetchMarksSubmissions,
  fetchSchoolNotices,
} from "../../offline/teacherApi";

export function useClassStudentsQuery(classId, options = {}) {
  return useQuery({
    queryKey: queryKeys.classStudents(classId),
    queryFn: () => fetchClassStudents(classId),
    enabled: Boolean(classId) && (options.enabled !== false),
    ...options,
  });
}

export function useClassMetaQuery(classId, options = {}) {
  return useQuery({
    queryKey: queryKeys.classMeta(classId),
    queryFn: () => fetchClassMeta(classId),
    enabled: Boolean(classId) && (options.enabled !== false),
    ...options,
  });
}

export function useAttendanceSubmissionsQuery(teacherId, recordsScope = "current", options = {}) {
  return useQuery({
    queryKey: queryKeys.attendanceSubmissions(teacherId, recordsScope),
    queryFn: () => fetchAttendanceSubmissions(teacherId, recordsScope),
    enabled: Boolean(teacherId) && (options.enabled !== false),
    ...options,
  });
}

export function useMarksSubmissionsQuery(teacherId, recordsScope = "current", options = {}) {
  return useQuery({
    queryKey: queryKeys.marksSubmissions(teacherId, recordsScope),
    queryFn: () => fetchMarksSubmissions(teacherId, recordsScope),
    enabled: Boolean(teacherId) && (options.enabled !== false),
    ...options,
  });
}

export function useSchoolNoticesQuery(schoolId, options = {}) {
  return useQuery({
    queryKey: queryKeys.schoolNotices(schoolId),
    queryFn: () => fetchSchoolNotices(schoolId),
    enabled: Boolean(schoolId) && (options.enabled !== false),
    ...options,
  });
}
